import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NegotiationResultItem } from '../../../external/NegotiationListApi';
import { actions } from '../../modules/Actions';

export interface SearchResultItem extends NegotiationResultItem {
  key?: string;
}

export interface SearchResultState {
  hit: number;
  searchResultList: SearchResultItem[];
}

export const initialState: SearchResultState = {
  hit: 0,
  searchResultList: [],
};

export const SearchResultReducer = reducerWithInitialState(initialState).case(
  actions.updateSearchResult,
  (state: SearchResultState, payload: SearchResultState) => {
    return payload;
  }
);
